module.exports = __webpack_public_path__ + "img/cly.f6863a17.png";